export const fieldAllowRegex = () => {
  const regexFunction = ({ elements, testRegex }) => {
    if (elements && testRegex) {
      elements.forEach((element) => {
        let oldValue = "";
        element.addEventListener("input", function (event) {
          const input = event.target;
          if (input.value.length === 0) {
            input.value = "";
            oldValue = "";
          } else if (testRegex.test(input.value)) {
            oldValue = input.value;
          } else {
            input.value = oldValue;
          }
        });
      });
    }
  };

  regexFunction({
    elements: document.querySelectorAll(`[js-only-numbers]`),
    testRegex: /^\d+$/,
  });

  regexFunction({
    elements: document.querySelectorAll(`[js-only-characters]`),
    testRegex: /^[\D]+$/,
  });
};
